const get = require('lodash/get')

// Groups a flat issues list (as produced row-by-row by runContentChecks)
// into one entry per rule code, each expanding to every row it fired on.
// Each row carries its own list of cells that violated the rule.

const groupIssuesByRule = (issues = []) => {
  const groupsByCode = new Map()

  issues.forEach(issue => {
    if (!groupsByCode.has(issue.code)) {
      groupsByCode.set(issue.code, {
        code: issue.code,
        name: issue.name,
        description: issue.description,
        scope: issue.scope,
        severity: issue.severity,
        rowsByNumber: new Map()
      })
    }

    const group = groupsByCode.get(issue.code)
    if (!group.rowsByNumber.has(issue.row)) {
      const allRowsAffected = get(issue, 'allRowsAffected')
      const identityOfAllRowsAffected = get(issue, 'identityOfAllRowsAffected')
      const existingManufacturerWithSimilarName = get(issue, 'existingManufacturerWithSimilarName')
      const manufacturerUsedInSheet = get(issue, 'manufacturerUsedInSheet')

      group.rowsByNumber.set(issue.row, {
        row: issue.row,
        rowIdentity: issue.rowIdentity,
        ...(allRowsAffected && { allRowsAffected }),
        ...(identityOfAllRowsAffected && { identityOfAllRowsAffected }),
        ...(existingManufacturerWithSimilarName && { existingManufacturerWithSimilarName }),
        ...(manufacturerUsedInSheet && { manufacturerUsedInSheet }),
        fields: []
      })
    }

    const rowEntry = group.rowsByNumber.get(issue.row)
    ;(issue.fields || []).forEach(field => {
      rowEntry.fields.push({ field })
    })
  })

  return Array.from(groupsByCode.values()).map(group => ({
    code: group.code,
    name: group.name,
    description: group.description,
    scope: group.scope,
    severity: group.severity,
    rows: Array.from(group.rowsByNumber.values())
  }))
}

module.exports = { groupIssuesByRule }
